import types from '../Types/globalFilterTypes'

const initialvalues = {
  SN: ""
};

const globalSearchReducer = (state = initialvalues, action) => {
  switch (action.type) {
    case types.GLOBAL_FILTER_SN_SET:
      return {
        ...state,
        SN: action.SN,        
      };    
    default:
      return state;
  }
}

export default globalSearchReducer;
